module.exports = __webpack_public_path__ + "static/usha-Fun-34aae26c64e97d2d73de0d09790b62d5.jpg";